import axios from "axios";

export default {
  namespaced: true,
  state: {
    id: null,
    login: null,
    password: null,
    schoolId: null,
    selectedSubjects: null,          // 【担当教科】描画用に加工された、現在選択済みのもの
    subjectTeachers: [],             // 【担当教科】DBから取得した無加工のもの
    subjectTeachersAttributes: null, // 【担当教科】登録用に整形済みのもの
    selectedSubjectOptions: [],    // 【担当教科】分野選択用のオプション
    accountType: 'free',
    remainingDownloadCount: '5',
    isShingaku: false,
  },

  getters: {
    title: state => {
      return state.id ? '編集' : '新規作成'
    },
    isEdit: state => {
      return state.id ? true : false
    },
    passwordLabel: state => {
      return state.id ? 'パスワード再設定' : 'パスワード'
    },
    url: state => {
      return state.id
        ? `api/v1/admin/teachers/${state.id}`
        : 'api/v1/admin/teachers'
    },
    method: state => {
      return state.id ? 'PUT' : 'POST'
    },
    data( state, getters, rootState ) {
      return {
        type:      'Teacher',
        login:     state.login,
        uid:       state.login,
        password:  state.password,
        school_id: rootState.school.id,
        subject_teachers_attributes: state.subjectTeachersAttributes,
        account_type: state.accountType,
        remaining_download_count: state.remainingDownloadCount,
        is_shingaku: state.isShingaku,
      };
    },
  },

  mutations: {
    setId(state, payload) {
      state.id = payload.id;
    },
    setLogin(state, payload) {
      state.login = payload.login
    },
    setPassword(state, payload) {
      state.password = payload.password
    },
    setSelectedSubjects(state, payload) {
      state.selectedSubjects = payload.selectedSubjects
    },
    setSelectedSubjectOptions(state, payload) {
      state.selectedSubjectOptions = payload.selectedSubjectOptions
    },
    setSubjectTeachersAttributes(state, payload) {
      state.subjectTeachersAttributes = payload.subjectTeachersAttributes
    },
    setSchoolId(state, payload) {
      state.schoolId = payload.schoolId
    },
    setAccountType(state, payload) {
      state.accountType = payload.accountType
    },
    setRemainingDownloadCount(state, payload) {
      state.remainingDownloadCount = payload.remainingDownloadCount
    },
    setIsShingaku(state, payload) {
      state.isShingaku = payload.isShingaku
    },
    setAccount(state, payload) {
      state.id               = payload.id;
      state.login            = payload.login_id;
      state.password         = payload.password;
      state.selectedSubjects = payload.selectedSubjects;
      state.subjectTeachers  = payload.subject_teachers;
      state.accountType      = payload.account_type;
      state.remainingDownloadCount = payload.remaining_download_count ? String(payload.remaining_download_count) : '-';
      state.selectedSubjectOptions  = payload.selectedSubjectOptions;
      state.isShingaku     = payload.is_shingaku;
    },
    initialize(state) {
      state.id               = '';
      state.login            = '';
      state.password         = '';
      state.selectedSubjects = '';
      state.subjectTeachers  = [];
      state.accountType      = 'free';
      state.remainingDownloadCount = '5';
      state.selectedSubjectOptions = [];
      state.isShingaku       = false;
    },
  },

  actions: {

    async validate({ state }) {
      // ログインIDが入力されているか
      if (!state.login) return {status: 'error', message: 'ログインIDを入力してください'}
      // ログインIDが15文字以内か
      if (state.login.length > 16) return {status: 'error', message: 'ログインIDは10文字以内で入力してください'}
      // ログインIDが半角英数か(ハイフン含む)
      if (!state.login.match(/^[a-zA-Z0-9\\-]+$/)) return {status: 'error', message: 'ログインIDは半角英数字とハイフン「-」のみで入力してください'}

      if (!state.id) {
        // パスワードが入力されているか（必須チェックは新規登録時のみ）
        if (!state.password) return {status: 'error', message: 'パスワードを入力してください'}
      }
      if(!state.id || (state.id && state.password)) {
        // パスワードチェックを行うのは新規登録の時、編集でパスワード再設定を行う時
        // パスワードが10文字以内か
        if (state.password.length > 10) return {status: 'error', message: 'パスワードは10文字以内で入力してください'}
        // パスワードが半角英数か
        if (state.password != null && !state.password.match(/^[a-zA-Z0-9]+$/)) return {status: 'error', message: 'パスワードは半角英数字で入力してください'}
      }

      // 担当教科が選択されているか
      function isEmpty(obj){
        return !Object.keys(obj).length;
      }
      if (isEmpty(state.selectedSubjects) && isEmpty(state.selectedSubjectOptions)) return {status: 'error', message: '担当教科を選択してください'}

      if (!state.accountType) return {status: 'error', message: 'アカウント体型を入力してください'}
      if (state.accountType === 'free') {
       if (!state.remainingDownloadCount) return {status: 'error', message: '残りダウンロード回数を入力してください'}
      if (state.remainingDownloadCount.match(/[^0-9]/)) return {status: 'error', message: '残りダウンロード回数は数字で入力してください'}
       if (Number(state.remainingDownloadCount) < 0) return {status: 'error', message: '残りダウンロード回数は0以上の数字で入力してください'}
       if (Number(state.remainingDownloadCount) > 30) return {status: 'error', message: '残りダウンロード回数は30以内の数字で入力してください'}
      }

      return {status: 'success', message: ''}
    },

    async submit({ getters }) {
      const data    = getters.data
      const url     = getters.url
      const method  = getters.method
      const title   = getters.title

      await axios({
        url: url,
        method: method,
        data: data,
      })
      return {message: `${title}が完了しました` }
    },
  },
}
